/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
  fill?: string;
};

const UserGroupIcon: FC<IProps> = ({ width = 22, height = 20, color = "#262626", fill = "none" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 20"
    fill={fill}
  >
    <path
      d="M15 19.1328V17.1328C15 16.0719 14.5786 15.0545 13.8284 14.3044C13.0783 13.5542 12.0609 13.1328 11 13.1328H5C3.93913 13.1328 2.92172 13.5542 2.17157 14.3044C1.42143 15.0545 1 16.0719 1 17.1328V19.1328M15 1.26081C15.8578 1.48318 16.6174 1.98408 17.1597 2.68488C17.702 3.38567 17.9962 4.2467 17.9962 5.13281C17.9962 6.01892 17.702 6.87995 17.1597 7.58075C16.6174 8.28155 15.8578 8.78244 15 9.00481M21 19.1328V17.1328C20.9993 16.2465 20.7044 15.3856 20.1614 14.6851C19.6184 13.9847 18.8581 13.4844 18 13.2628M12 5.13281C12 7.34195 10.2091 9.13281 8 9.13281C5.79086 9.13281 4 7.34195 4 5.13281C4 2.92367 5.79086 1.13281 8 1.13281C10.2091 1.13281 12 2.92367 12 5.13281Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserGroupIcon;
